/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import Header from '../Header';
import EventPlayer4 from '../EventPlayer4';
import StyleContainerVideo from './style';

class EventPlayerRoute extends Component {
  render() {
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header />
        <StyleContainerVideo>
          <EventPlayer4 />
        </StyleContainerVideo>
      </div>
    );
  }
}

export default EventPlayerRoute;
